import React, { useState, useCallback } from 'react';
import { formatPrice } from '@moda/portal-stanchions';
import { useCart } from '../../hooks/useCart';
import { EditableSection } from '../EditableSection';
import { CheckoutSection } from '../CheckoutSection';
import { CheckoutSiteCreditForm } from './CheckoutSiteCreditForm';

enum Mode {
  Resting,
  Editing
}

export const CheckoutSiteCredit: React.FC = () => {
  const [mode, setMode] = useState(Mode.Resting);
  const {
    cart: {
      attributes: {
        siteCreditAvailable,
        paymentSummary: { siteCredit: siteCreditApplied }
      }
    }
  } = useCart();

  const onChange = useCallback(() => {
    setMode(Mode.Editing);
  }, [setMode]);

  const onCloseForm = useCallback(() => {
    setMode(Mode.Resting);
  }, [setMode]);

  if (!siteCreditAvailable || Number(siteCreditAvailable.price) === 0) return null;

  return (
    <CheckoutSection title="Site Credit">
      {mode === Mode.Resting && (
        <EditableSection
          changeLabel={Number(siteCreditApplied.price) > 0 ? 'Change' : 'Apply'}
          onChange={onChange}
          location="checkout-site-credit"
        >
          <span>
            {Number(siteCreditApplied.price) > 0
              ? `${formatPrice(
                  siteCreditApplied.currency,
                  siteCreditApplied.price
                )} site credit applied`
              : `${formatPrice(
                  siteCreditAvailable.currency,
                  siteCreditAvailable.price
                )} site credit available`}
          </span>
        </EditableSection>
      )}
      {mode === Mode.Editing && <CheckoutSiteCreditForm onClose={onCloseForm} />}
    </CheckoutSection>
  );
};
